var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 80,
    viewBox: "0 0 224 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.639 57.369C34.4586 62.5181 33.0832 69.1241 33.6381 74.7695C31.586 73.5287 30.7582 71.6688 27.6649 69.6131C19.526 64.2057 12.311 62.5373 2.32147 61.3643L2.19235 31.728C15.5215 32.2545 28.4267 45.4454 32.6381 57.369H32.639ZM65.6983 31.5394C65.6525 36.4833 66.288 58.4468 65.473 61.1967C61.8028 62.4631 56.6702 61.7342 47.6358 65.9035C45.0855 67.0802 42.3658 68.5637 40.3705 70.0407L37.2369 72.6056C36.5464 73.1569 36.3294 73.33 35.7406 73.9563C34.7846 74.9746 34.8771 75.014 33.9055 75.1596C35.2983 65.4997 31.3726 61.3038 38.0244 49.9434C43.4555 40.6672 54.7793 31.8058 65.6992 31.5394H65.6983ZM17.125 34.564C13.9474 34.314 12.8302 29.8352 12.985 26.535C13.343 18.8942 20.4499 15.7698 26.8856 18.0985C30.4642 19.3933 31.4926 21.0095 33.6537 23.1358L35.2589 21.4884C39.5875 17.1113 45.8877 16.0335 50.3335 19.0471C54.3727 21.7851 55.5979 33.4147 49.1961 35.0951C49.687 32.6162 52.0477 30.8645 52.1246 26.8628C52.185 23.6752 50.012 21.0562 47.9856 20.1359C40.0728 16.5436 34.7699 25.4736 33.6546 26.4938C32.9046 26.0835 32.9092 25.9132 32.27 25.0735C24.3252 14.6288 15.2395 20.7064 14.745 26.2978C14.593 28.023 14.9062 29.3151 15.4345 30.8297C15.9611 32.3406 16.8072 33.4111 17.125 34.564ZM18.4408 15.2927C21.4087 9.91651 36.2085 6.2509 45.5974 12.6783C47.6449 14.0803 47.9306 13.9576 48.2493 15.2432C37.6526 13.2589 36.1169 18.0627 33.3377 19.2184C28.9102 14.996 25.3646 13.9539 18.4418 15.2927H18.4408ZM56.1327 31.7088C56.8277 26.9635 57.5676 25.4334 55.8003 20.5572C48.9791 1.74099 18.819 0.136652 10.7378 21.0407C9.00438 25.5249 9.64813 27.6118 10.5135 31.923C7.41469 30.9231 4.12177 30.0724 0.584351 30.0467L0.588014 63.095C7.66376 63.2186 15.6195 65.1819 21.2237 67.8137C33.889 73.7613 31.4633 77.5652 34.2883 80.0001C35.6747 78.751 35.4393 76.5698 39.6113 72.7622C46.2924 66.6645 57.9275 63.3807 67.5636 62.8679L67.5389 29.935C62.8999 29.9826 60.3413 30.9744 56.1327 31.7088Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 22.5516C105.721 25.0496 106.111 34.7709 106.151 37.9558C106.221 43.3585 106.749 46.4912 109.217 50.5286C112.516 55.9231 119.556 58.14 125.78 56.1813C128.499 55.3251 129.132 54.272 131.177 53.49C131.099 57.1245 130.241 57.3598 133.807 57.347C136.815 57.336 137.142 57.7179 139.43 56.5961C140.002 53.4982 140 24.5744 139.315 22.6605C136.97 21.8263 131.547 21.786 130.462 24.1092C129.938 25.2309 130.186 32.3204 130.185 34.1528C130.182 38.7076 131.703 48.4435 122.723 48.3134C111.238 48.1468 117.654 28.1274 115.447 23.6596C114.438 21.6184 108.853 22.0525 106.323 22.5525V22.5516Z",
    fill: "#4F46E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3038 57.3497C94.54 50.8408 91.4824 42.3448 95.0061 36.5629L105.843 19.5068C106.627 18.3255 107.423 16.6983 106.325 15.364C105.537 14.4071 99.2385 13.2158 97.4831 15.8695L90.0044 28.022C89.8881 28.2262 89.6757 28.6145 89.4981 28.8178C88.9056 29.4963 89.5044 29.033 88.5494 29.6099C87.6996 27.3215 85.468 24.1375 84.0889 21.7255C82.9516 19.7375 80.4498 14.9236 78.9517 14.5234C77.8327 14.224 73.7935 14.2075 72.6717 14.5014C67.7681 15.7889 74.0068 23.2649 75.8108 25.9552C77.4399 28.3837 78.9719 31.0027 80.5524 33.541C82.9122 37.3312 83.632 37.3037 83.6713 42.7074C83.751 53.6017 81.8637 57.3744 87.5256 57.3488C89.4541 57.3396 91.3762 57.3341 93.3047 57.3479L93.3038 57.3497Z",
    fill: "#4F46E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.813 10.6142C144.631 8.61246 145.872 12.3403 145.885 17.668C145.9 23.1623 145.908 28.6575 145.879 34.1509C145.738 60.91 144.132 57.6299 155.356 57.3149C155.123 49.4672 155.272 41.3878 155.262 33.5172C155.255 29.2683 155.718 13.3055 154.813 10.6133V10.6142Z",
    fill: "#4F46E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.187 57.2747C171.122 54.2428 171.343 25.0735 170.987 23.8803C170.504 22.2586 168.79 22.2485 166.79 22.2439C159.536 22.2274 161.534 22.8987 161.51 44.9281C161.497 55.9103 160.294 57.3983 165.832 57.3727C167.625 57.3644 169.396 57.369 171.187 57.2738V57.2747Z",
    fill: "#4F46E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4406 15.2918C25.3644 13.953 28.9091 14.9951 33.3366 19.2175C36.1158 18.0618 37.6515 13.258 48.2481 15.2423C47.9304 13.9567 47.6438 14.0794 45.5962 12.6774C36.2083 6.24906 21.4075 9.9156 18.4397 15.2918H18.4406Z",
    fill: "#7C459C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1256 34.5639C16.8078 33.4111 15.9617 32.3406 15.4352 30.8297C14.9068 29.3151 14.5936 28.023 14.7456 26.2978C15.2392 20.7064 24.3259 14.6279 32.2706 25.0735C32.9098 25.9132 32.9052 26.0835 33.6552 26.4937C34.7696 25.4736 40.0735 16.5435 47.9862 20.1359C50.0127 21.0562 52.1857 23.6752 52.1252 26.8628C52.0492 30.8645 49.6876 32.6162 49.1968 35.0951C55.5986 33.4147 54.3733 21.786 50.3341 19.0471C45.8883 16.0335 39.5881 17.1113 35.2595 21.4884L33.6543 23.1358C31.4932 21.0095 30.4648 19.3942 26.8862 18.0984C20.4506 15.7698 13.3437 18.8942 12.9856 26.5349C12.8309 29.8352 13.948 34.314 17.1256 34.5639Z",
    fill: "#6C3695"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2582_56727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 31,
    width: 32,
    height: 44
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6392 57.3689C28.4278 45.4454 15.5226 32.2544 2.19342 31.7279L2.32254 61.3642C12.3121 62.5372 19.5261 64.2057 27.6659 69.613C30.7592 71.6688 31.5861 73.5286 33.6392 74.7694C33.0833 69.124 34.4587 62.518 32.6401 57.3689H32.6392Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2582_56727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19342 31.7279H2.25477V74.7694H2.19342V31.7279Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19342 31.7279H2.37748V74.7694H2.19342V31.7279Z",
    fill: "#3D008C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31592 31.7279H2.49998V74.7694H2.31592V31.7279Z",
    fill: "#3D008C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43835 31.7279H2.62333V74.7694H2.43835V31.7279Z",
    fill: "#3E008D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56152 31.7279H2.7465V74.7694H2.56152V31.7279Z",
    fill: "#3E008D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68475 31.7279H2.86881V74.7694H2.68475V31.7279Z",
    fill: "#3F008E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80792 31.7279H2.99198V74.7694H2.80792V31.7279Z",
    fill: "#3F008E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93036 31.7279H3.11442V74.7694H2.93036V31.7279Z",
    fill: "#3F008F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0528 31.7279H3.23685V74.7694H3.0528V31.7279Z",
    fill: "#40008F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17529 31.7279H3.36027V74.7694H3.17529V31.7279Z",
    fill: "#400090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29846 31.7279H3.48344V74.7694H3.29846V31.7279Z",
    fill: "#410090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42242 31.7279H3.60648V74.7694H3.42242V31.7279Z",
    fill: "#410091"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54486 31.7279H3.72892V74.7694H3.54486V31.7279Z",
    fill: "#410091"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6673 31.7279H3.85136V74.7694H3.6673V31.7279Z",
    fill: "#420092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78973 31.7279H3.97379V74.7694H3.78973V31.7279Z",
    fill: "#420092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91296 31.7279H4.09702V74.7694H3.91296V31.7279Z",
    fill: "#420093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0354 31.7279H4.21946V74.7694H4.0354V31.7279Z",
    fill: "#430093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15857 31.7279H4.34355V74.7694H4.15857V31.7279Z",
    fill: "#430094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2818 31.7279H4.46586V74.7694H4.2818V31.7279Z",
    fill: "#440094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40424 31.7279H4.5883V74.7694H4.40424V31.7279Z",
    fill: "#440095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5274 31.7279H4.71146V74.7694H4.5274V31.7279Z",
    fill: "#440095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6499 31.7279H4.83396V74.7694H4.6499V31.7279Z",
    fill: "#450096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77307 31.7279H4.95713V74.7694H4.77307V31.7279Z",
    fill: "#450096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89551 31.7279H5.07957V74.7694H4.89551V31.7279Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01794 31.7279H5.202V74.7694H5.01794V31.7279Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14117 31.7279H5.32615V74.7694H5.14117V31.7279Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26434 31.7279H5.4484V74.7694H5.26434V31.7279Z",
    fill: "#470098"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38757 31.7279H5.57163V74.7694H5.38757V31.7279Z",
    fill: "#470098"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51001 31.7279H5.69407V74.7694H5.51001V31.7279Z",
    fill: "#480099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63245 31.7279H5.81651V74.7694H5.63245V31.7279Z",
    fill: "#480099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75488 31.7279H5.93894V74.7694H5.75488V31.7279Z",
    fill: "#48009A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87811 31.7279H6.06217V74.7694H5.87811V31.7279Z",
    fill: "#49009A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00055 31.7279H6.18552V74.7694H6.00055V31.7279Z",
    fill: "#49009B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12451 31.7279H6.30857V74.7694H6.12451V31.7279Z",
    fill: "#4A009B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24695 31.7279H6.43101V74.7694H6.24695V31.7279Z",
    fill: "#4A009C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36938 31.7279H6.55344V74.7694H6.36938V31.7279Z",
    fill: "#4A009C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49255 31.7279H6.67661V74.7694H6.49255V31.7279Z",
    fill: "#4B009D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61499 31.7279H6.79905V74.7694H6.61499V31.7279Z",
    fill: "#4B009D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73822 31.7279H6.92319V74.7694H6.73822V31.7279Z",
    fill: "#4C009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86066 31.7279H7.04563V74.7694H6.86066V31.7279Z",
    fill: "#4C009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98389 31.7279H7.16795V74.7694H6.98389V31.7279Z",
    fill: "#4C009F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10706 31.7279H7.29112V74.7694H7.10706V31.7279Z",
    fill: "#4D009F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22949 31.7279H7.41355V74.7694H7.22949V31.7279Z",
    fill: "#4D00A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35272 31.7279H7.53678V74.7694H7.35272V31.7279Z",
    fill: "#4D00A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47516 31.7279H7.65922V74.7694H7.47516V31.7279Z",
    fill: "#4E00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5976 31.7279H7.78165V74.7694H7.5976V31.7279Z",
    fill: "#4E00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72076 31.7279H7.90574V74.7694H7.72076V31.7279Z",
    fill: "#4F00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84326 31.7279H8.02824V74.7694H7.84326V31.7279Z",
    fill: "#4F00A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96716 31.7279H8.15122V74.7694H7.96716V31.7279Z",
    fill: "#4F00A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0896 31.7279H8.27366V74.7694H8.0896V31.7279Z",
    fill: "#5000A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2121 31.7279H8.39616V74.7694H8.2121V31.7279Z",
    fill: "#5000A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33453 31.7279H8.51859V74.7694H8.33453V31.7279Z",
    fill: "#5100A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4577 31.7279H8.64176V74.7694H8.4577V31.7279Z",
    fill: "#5100A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58014 31.7279H8.7642V74.7694H8.58014V31.7279Z",
    fill: "#5100A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70264 31.7279H8.88761V74.7694H8.70264V31.7279Z",
    fill: "#5200A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82581 31.7279H9.01078V74.7694H8.82581V31.7279Z",
    fill: "#5200A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94897 31.7279H9.13303V74.7694H8.94897V31.7279Z",
    fill: "#5300A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0722 31.7279H9.25626V74.7694H9.0722V31.7279Z",
    fill: "#5300A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19464 31.7279H9.3787V74.7694H9.19464V31.7279Z",
    fill: "#5300A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31708 31.7279H9.50113V74.7694H9.31708V31.7279Z",
    fill: "#5400A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44031 31.7279H9.62528V74.7694H9.44031V31.7279Z",
    fill: "#5400A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56274 31.7279H9.74772V74.7694H9.56274V31.7279Z",
    fill: "#5500A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68671 31.7279H9.87076V74.7694H9.68671V31.7279Z",
    fill: "#5500A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80914 31.7279H9.9932V74.7694H9.80914V31.7279Z",
    fill: "#5500AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93158 31.7279H10.1156V74.7694H9.93158V31.7279Z",
    fill: "#5600AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0547 31.7279H10.2388V74.7694H10.0547V31.7279Z",
    fill: "#5600AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1772 31.7279H10.3613V74.7694H10.1772V31.7279Z",
    fill: "#5600AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3004 31.7279H10.4854V74.7694H10.3004V31.7279Z",
    fill: "#5700AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4229 31.7279H10.6078V74.7694H10.4229V31.7279Z",
    fill: "#5700AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5461 31.7279H10.7301V74.7694H10.5461V31.7279Z",
    fill: "#5800AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6693 31.7279H10.8533V74.7694H10.6693V31.7279Z",
    fill: "#5800AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7917 31.7279H10.9757V74.7694H10.7917V31.7279Z",
    fill: "#5800AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9141 31.7279H11.0982V74.7694H10.9141V31.7279Z",
    fill: "#5900AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0374 31.7279H11.2214V74.7694H11.0374V31.7279Z",
    fill: "#5900AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1598 31.7279H11.3438V74.7694H11.1598V31.7279Z",
    fill: "#5A00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2822 31.7279H11.4672V74.7694H11.2822V31.7279Z",
    fill: "#5A00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4055 31.7279H11.5904V74.7694H11.4055V31.7279Z",
    fill: "#5A00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5286 31.7279H11.7127V74.7694H11.5286V31.7279Z",
    fill: "#5B00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6519 31.7279H11.8359V74.7694H11.6519V31.7279Z",
    fill: "#5B00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7743 31.7279H11.9584V74.7694H11.7743V31.7279Z",
    fill: "#5C00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8967 31.7279H12.0808V74.7694H11.8967V31.7279Z",
    fill: "#5C00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0199 31.7279H12.204V74.7694H12.0199V31.7279Z",
    fill: "#5C00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1423 31.7279H12.3264V74.7694H12.1423V31.7279Z",
    fill: "#5D00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2656 31.7279H12.4505V74.7694H12.2656V31.7279Z",
    fill: "#5D00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.388 31.7279H12.573V74.7694H12.388V31.7279Z",
    fill: "#5E00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5112 31.7279H12.6953V74.7694H12.5112V31.7279Z",
    fill: "#5E00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6344 31.7279H12.8185V74.7694H12.6344V31.7279Z",
    fill: "#5E00B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7568 31.7279H12.9409V74.7694H12.7568V31.7279Z",
    fill: "#5F00B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8801 31.7279H13.0641V74.7694H12.8801V31.7279Z",
    fill: "#5F00B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0025 31.7279H13.1875V74.7694H13.0025V31.7279Z",
    fill: "#6000B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1249 31.7279H13.3099V74.7694H13.1249V31.7279Z",
    fill: "#6000B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2489 31.7279H13.433V74.7694H13.2489V31.7279Z",
    fill: "#6000B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3713 31.7279H13.5554V74.7694H13.3713V31.7279Z",
    fill: "#6100B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4938 31.7279H13.6778V74.7694H13.4938V31.7279Z",
    fill: "#6100B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6169 31.7279H13.801V74.7694H13.6169V31.7279Z",
    fill: "#6100B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7394 31.7279H13.9235V74.7694H13.7394V31.7279Z",
    fill: "#6200B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8619 31.7279H14.0469V74.7694H13.8619V31.7279Z",
    fill: "#6200B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.985 31.7279H14.17V74.7694H13.985V31.7279Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1083 31.7279H14.2923V74.7694H14.1083V31.7279Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2314 31.7279H14.4155V74.7694H14.2314V31.7279Z",
    fill: "#6300BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3539 31.7279H14.5379V74.7694H14.3539V31.7279Z",
    fill: "#6400BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4763 31.7279H14.6604V74.7694H14.4763V31.7279Z",
    fill: "#6400BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5995 31.7279H14.7836V74.7694H14.5995V31.7279Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.722 31.7279H14.906V74.7694H14.722V31.7279Z",
    fill: "#6500BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8444 31.7279H15.0294V74.7694H14.8444V31.7279Z",
    fill: "#6500BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9677 31.7279H15.1526V74.7694H14.9677V31.7279Z",
    fill: "#6600BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0908 31.7279H15.2749V74.7694H15.0908V31.7279Z",
    fill: "#6600BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2141 31.7279H15.3981V74.7694H15.2141V31.7279Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3365 31.7279H15.5205V74.7694H15.3365V31.7279Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4589 31.7279H15.643V74.7694H15.4589V31.7279Z",
    fill: "#6700C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5821 31.7279H15.7662V74.7694H15.5821V31.7279Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7046 31.7279H15.8886V74.7694H15.7046V31.7279Z",
    fill: "#6800C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.827 31.7279H16.012V74.7694H15.827V31.7279Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9509 31.7279H16.135V74.7694H15.9509V31.7279Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0734 31.7279H16.2575V74.7694H16.0734V31.7279Z",
    fill: "#6900C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1966 31.7279H16.3807V74.7694H16.1966V31.7279Z",
    fill: "#6A00C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.319 31.7279H16.5031V74.7694H16.319V31.7279Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4415 31.7279H16.6255V74.7694H16.4415V31.7279Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5647 31.7279H16.7497V74.7694H16.5647V31.7279Z",
    fill: "#6B00C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6879 31.7279H16.8719V74.7694H16.6879V31.7279Z",
    fill: "#6B00C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8111 31.7279H16.9952V74.7694H16.8111V31.7279Z",
    fill: "#6B00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9335 31.7279H17.1176V74.7694H16.9335V31.7279Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.056 31.7279H17.24V74.7694H17.056V31.7279Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1792 31.7279H17.3633V74.7694H17.1792V31.7279Z",
    fill: "#6A00C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3016 31.7279H17.4857V74.7694H17.3016V31.7279Z",
    fill: "#6900C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4241 31.7279H17.6081V74.7694H17.4241V31.7279Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5472 31.7279H17.7322V74.7694H17.5472V31.7279Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6705 31.7279H17.8545V74.7694H17.6705V31.7279Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7936 31.7279H17.9777V74.7694H17.7936V31.7279Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9161 31.7279H18.1001V74.7694H17.9161V31.7279Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0386 31.7279H18.2226V74.7694H18.0386V31.7279Z",
    fill: "#6800BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.161 31.7279H18.3451V74.7694H18.161V31.7279Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2842 31.7279H18.4682V74.7694H18.2842V31.7279Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4066 31.7279H18.5907V74.7694H18.4066V31.7279Z",
    fill: "#6700BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5298 31.7279H18.7148V74.7694H18.5298V31.7279Z",
    fill: "#6700BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.653 31.7279H18.8371V74.7694H18.653V31.7279Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7755 31.7279H18.9595V74.7694H18.7755V31.7279Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8987 31.7279H19.0827V74.7694H18.8987V31.7279Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0211 31.7279H19.2052V74.7694H19.0211V31.7279Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1443 31.7279H19.3283V74.7694H19.1443V31.7279Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2668 31.7279H19.4518V74.7694H19.2668V31.7279Z",
    fill: "#6500BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3892 31.7279H19.5742V74.7694H19.3892V31.7279Z",
    fill: "#6500BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5132 31.7279H19.6972V74.7694H19.5132V31.7279Z",
    fill: "#6400BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6356 31.7279H19.8197V74.7694H19.6356V31.7279Z",
    fill: "#6400BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7588 31.7279H19.9428V74.7694H19.7588V31.7279Z",
    fill: "#6400BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8812 31.7279H20.0653V74.7694H19.8812V31.7279Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0037 31.7279H20.1877V74.7694H20.0037V31.7279Z",
    fill: "#6300B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1269 31.7279H20.3119V74.7694H20.1269V31.7279Z",
    fill: "#6300B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2501 31.7279H20.4341V74.7694H20.2501V31.7279Z",
    fill: "#6300B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3733 31.7279H20.5574V74.7694H20.3733V31.7279Z",
    fill: "#6200B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4957 31.7279H20.6798V74.7694H20.4957V31.7279Z",
    fill: "#6200B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6182 31.7279H20.8022V74.7694H20.6182V31.7279Z",
    fill: "#6200B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7406 31.7279H20.9247V74.7694H20.7406V31.7279Z",
    fill: "#6100B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8638 31.7279H21.0479V74.7694H20.8638V31.7279Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9863 31.7279H21.1703V74.7694H20.9863V31.7279Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1094 31.7279H21.2944V74.7694H21.1094V31.7279Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2327 31.7279H21.4167V74.7694H21.2327V31.7279Z",
    fill: "#6000B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3551 31.7279H21.5392V74.7694H21.3551V31.7279Z",
    fill: "#6000B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4783 31.7279H21.6623V74.7694H21.4783V31.7279Z",
    fill: "#6000B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6008 31.7279H21.7848V74.7694H21.6008V31.7279Z",
    fill: "#5F00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7239 31.7279H21.908V74.7694H21.7239V31.7279Z",
    fill: "#5F00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8464 31.7279H22.0304V74.7694H21.8464V31.7279Z",
    fill: "#5F00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9688 31.7279H22.1529V74.7694H21.9688V31.7279Z",
    fill: "#5F00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.092 31.7279H22.277V74.7694H22.092V31.7279Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2152 31.7279H22.3993V74.7694H22.2152V31.7279Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3384 31.7279H22.5225V74.7694H22.3384V31.7279Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4609 31.7279H22.6449V74.7694H22.4609V31.7279Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5833 31.7279H22.7674V74.7694H22.5833V31.7279Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7065 31.7279H22.8906V74.7694H22.7065V31.7279Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.829 31.7279H23.014V74.7694H22.829V31.7279Z",
    fill: "#5D00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9529 31.7279H23.1369V74.7694H22.9529V31.7279Z",
    fill: "#5C00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0754 31.7279H23.2594V74.7694H23.0754V31.7279Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1978 31.7279H23.3819V74.7694H23.1978V31.7279Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3203 31.7279H23.5043V74.7694H23.3203V31.7279Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4434 31.7279H23.6275V74.7694H23.4434V31.7279Z",
    fill: "#5B00AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5659 31.7279H23.75V74.7694H23.5659V31.7279Z",
    fill: "#5B00AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6884 31.7279H23.8733V74.7694H23.6884V31.7279Z",
    fill: "#5B00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8123 31.7279H23.9963V74.7694H23.8123V31.7279Z",
    fill: "#5A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9348 31.7279H24.1188V74.7694H23.9348V31.7279Z",
    fill: "#5A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0579 31.7279H24.242V74.7694H24.0579V31.7279Z",
    fill: "#5A00AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1804 31.7279H24.3644V74.7694H24.1804V31.7279Z",
    fill: "#5A00AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3028 31.7279H24.4869V74.7694H24.3028V31.7279Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.426 31.7279H24.6101V74.7694H24.426V31.7279Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5485 31.7279H24.7325V74.7694H24.5485V31.7279Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6716 31.7279H24.8566V74.7694H24.6716V31.7279Z",
    fill: "#5800AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7949 31.7279H24.9789V74.7694H24.7949V31.7279Z",
    fill: "#5800AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9173 31.7279H25.1014V74.7694H24.9173V31.7279Z",
    fill: "#5800A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0405 31.7279H25.2246V74.7694H25.0405V31.7279Z",
    fill: "#5800A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.163 31.7279H25.347V74.7694H25.163V31.7279Z",
    fill: "#5701A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2861 31.7279H25.4702V74.7694H25.2861V31.7279Z",
    fill: "#5701A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4086 31.7279H25.5926V74.7694H25.4086V31.7279Z",
    fill: "#5701A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.531 31.7279H25.716V74.7694H25.531V31.7279Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6535 31.7279H25.8385V74.7694H25.6535V31.7279Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7774 31.7279H25.9615V74.7694H25.7774V31.7279Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8999 31.7279H26.084V74.7694H25.8999V31.7279Z",
    fill: "#5601A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0231 31.7279H26.2071V74.7694H26.0231V31.7279Z",
    fill: "#5501A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1455 31.7279H26.3296V74.7694H26.1455V31.7279Z",
    fill: "#5501A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2679 31.7279H26.4529V74.7694H26.2679V31.7279Z",
    fill: "#5501A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3912 31.7279H26.5761V74.7694H26.3912V31.7279Z",
    fill: "#5401A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5143 31.7279H26.6984V74.7694H26.5143V31.7279Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6376 31.7279H26.8216V74.7694H26.6376V31.7279Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.76 31.7279H26.9441V74.7694H26.76V31.7279Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8824 31.7279H27.0665V74.7694H26.8824V31.7279Z",
    fill: "#5301A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0056 31.7279H27.1897V74.7694H27.0056V31.7279Z",
    fill: "#5301A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1281 31.7279H27.3122V74.7694H27.1281V31.7279Z",
    fill: "#5301A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2513 31.7279H27.4363V74.7694H27.2513V31.7279Z",
    fill: "#5201A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3737 31.7279H27.5587V74.7694H27.3737V31.7279Z",
    fill: "#5201A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4969 31.7279H27.681V74.7694H27.4969V31.7279Z",
    fill: "#5201A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6201 31.7279H27.8042V74.7694H27.6201V31.7279Z",
    fill: "#5201A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7426 31.7279H27.9266V74.7694H27.7426V31.7279Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8658 31.7279H28.0498V74.7694H27.8658V31.7279Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9882 31.7279H28.1723V74.7694H27.9882V31.7279Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1107 31.7279H28.2947V74.7694H28.1107V31.7279Z",
    fill: "#50019F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2331 31.7279H28.4181V74.7694H28.2331V31.7279Z",
    fill: "#50019F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3563 31.7279H28.5413V74.7694H28.3563V31.7279Z",
    fill: "#50019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4795 31.7279H28.6635V74.7694H28.4795V31.7279Z",
    fill: "#50019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6027 31.7279H28.7868V74.7694H28.6027V31.7279Z",
    fill: "#4F019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7252 31.7279H28.9092V74.7694H28.7252V31.7279Z",
    fill: "#4F019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8476 31.7279H29.0317V74.7694H28.8476V31.7279Z",
    fill: "#4F019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9708 31.7279H29.1548V74.7694H28.9708V31.7279Z",
    fill: "#4E019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0933 31.7279H29.2782V74.7694H29.0933V31.7279Z",
    fill: "#4E019C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2164 31.7279H29.4014V74.7694H29.2164V31.7279Z",
    fill: "#4E019C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3396 31.7279H29.5237V74.7694H29.3396V31.7279Z",
    fill: "#4E019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4621 31.7279H29.6462V74.7694H29.4621V31.7279Z",
    fill: "#4D019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5853 31.7279H29.7693V74.7694H29.5853V31.7279Z",
    fill: "#4D019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7077 31.7279H29.8918V74.7694H29.7077V31.7279Z",
    fill: "#4D019A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8309 31.7279H30.0159V74.7694H29.8309V31.7279Z",
    fill: "#4C019A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9534 31.7279H30.1383V74.7694H29.9534V31.7279Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0765 31.7279H30.2606V74.7694H30.0765V31.7279Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1998 31.7279H30.3838V74.7694H30.1998V31.7279Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3222 31.7279H30.5063V74.7694H30.3222V31.7279Z",
    fill: "#4B0198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4454 31.7279H30.6294V74.7694H30.4454V31.7279Z",
    fill: "#4B0198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5679 31.7279H30.7519V74.7694H30.5679V31.7279Z",
    fill: "#4B0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6903 31.7279H30.8744V74.7694H30.6903V31.7279Z",
    fill: "#4B0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8127 31.7279H30.9977V74.7694H30.8127V31.7279Z",
    fill: "#4A0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9359 31.7279H31.1209V74.7694H30.9359V31.7279Z",
    fill: "#4A0196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0591 31.7279H31.2432V74.7694H31.0591V31.7279Z",
    fill: "#4A0196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1823 31.7279H31.3664V74.7694H31.1823V31.7279Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3047 31.7279H31.4888V74.7694H31.3047V31.7279Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4272 31.7279H31.6113V74.7694H31.4272V31.7279Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5504 31.7279H31.7345V74.7694H31.5504V31.7279Z",
    fill: "#490194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6729 31.7279H31.8569V74.7694H31.6729V31.7279Z",
    fill: "#480194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7953 31.7279H31.9803V74.7694H31.7953V31.7279Z",
    fill: "#480193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9185 31.7279H32.1035V74.7694H31.9185V31.7279Z",
    fill: "#480193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0417 31.7279H32.2257V74.7694H32.0417V31.7279Z",
    fill: "#470193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1649 31.7279H32.349V74.7694H32.1649V31.7279Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2874 31.7279H32.4714V74.7694H32.2874V31.7279Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4098 31.7279H32.5939V74.7694H32.4098V31.7279Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5322 31.7279H32.7163V74.7694H32.5322V31.7279Z",
    fill: "#460191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6555 31.7279H32.8404V74.7694H32.6555V31.7279Z",
    fill: "#460191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7794 31.7279H32.9634V74.7694H32.7794V31.7279Z",
    fill: "#460190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9019 31.7279H33.0859V74.7694H32.9019V31.7279Z",
    fill: "#450190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0243 31.7279H33.2083V74.7694H33.0243V31.7279Z",
    fill: "#450190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1467 31.7279H33.3308V74.7694H33.1467V31.7279Z",
    fill: "#45018F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2699 31.7279H33.454V74.7694H33.2699V31.7279Z",
    fill: "#45018F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3923 31.7279H33.5773V74.7694H33.3923V31.7279Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5156 31.7279H33.7005V74.7694H33.5156V31.7279Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6387 31.7279H33.8228V74.7694H33.6387V31.7279Z",
    fill: "#3D008C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2582_56727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 31,
    width: 33,
    height: 45
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6992 31.5393C54.7792 31.8058 43.4555 40.6672 38.0244 49.9434C31.3735 61.3038 35.2983 65.4996 33.9055 75.1595C34.877 75.013 34.7845 74.9745 35.7406 73.9563C36.3294 73.3299 36.5464 73.1559 37.2368 72.6056L40.3704 70.0407C42.3658 68.5636 45.0855 67.0801 47.6357 65.9034C56.6702 61.7342 61.8028 62.4631 65.473 61.1967C66.288 58.4468 65.6516 36.4833 65.6983 31.5393H65.6992Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2582_56727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7806 31.5393H33.9674V75.1595H33.7806V31.5393Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9053 31.5393H34.0931V75.1595H33.9053V31.5393Z",
    fill: "#3D008C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.03 31.5393H34.2178V75.1595H34.03V31.5393Z",
    fill: "#3D008C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1547 31.5393H34.3424V75.1595H34.1547V31.5393Z",
    fill: "#3E008D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2794 31.5393H34.4671V75.1595H34.2794V31.5393Z",
    fill: "#3E008D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4048 31.5393H34.5917V75.1595H34.4048V31.5393Z",
    fill: "#3F008E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5295 31.5393H34.7173V75.1595H34.5295V31.5393Z",
    fill: "#3F008E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.655 31.5393H34.8418V75.1595H34.655V31.5393Z",
    fill: "#3F008F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7797 31.5393H34.9674V75.1595H34.7797V31.5393Z",
    fill: "#40008F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9052 31.5393H35.092V75.1595H34.9052V31.5393Z",
    fill: "#400090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0298 31.5393H35.2176V75.1595H35.0298V31.5393Z",
    fill: "#410090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1545 31.5393H35.3414V75.1595H35.1545V31.5393Z",
    fill: "#410091"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2792 31.5393H35.467V75.1595H35.2792V31.5393Z",
    fill: "#410091"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4039 31.5393H35.5917V75.1595H35.4039V31.5393Z",
    fill: "#420092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5294 31.5393H35.7171V75.1595H35.5294V31.5393Z",
    fill: "#420092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6541 31.5393H35.8418V75.1595H35.6541V31.5393Z",
    fill: "#420093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7795 31.5393H35.9663V75.1595H35.7795V31.5393Z",
    fill: "#430093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9042 31.5393H36.092V75.1595H35.9042V31.5393Z",
    fill: "#430094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0297 31.5393H36.2165V75.1595H36.0297V31.5393Z",
    fill: "#440094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1537 31.5393H36.3414V75.1595H36.1537V31.5393Z",
    fill: "#440095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2791 31.5393H36.4659V75.1595H36.2791V31.5393Z",
    fill: "#440095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4038 31.5393H36.5915V75.1595H36.4038V31.5393Z",
    fill: "#450096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5292 31.5393H36.716V75.1595H36.5292V31.5393Z",
    fill: "#450096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6539 31.5393H36.8407V75.1595H36.6539V31.5393Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7787 31.5393H36.9664V75.1595H36.7787V31.5393Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9041 31.5393H37.0909V75.1595H36.9041V31.5393Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0281 31.5393H37.2158V75.1595H37.0281V31.5393Z",
    fill: "#470098"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1535 31.5393H37.3403V75.1595H37.1535V31.5393Z",
    fill: "#470098"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2782 31.5393H37.4659V75.1595H37.2782V31.5393Z",
    fill: "#480099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4029 31.5393H37.5906V75.1595H37.4029V31.5393Z",
    fill: "#480099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5284 31.5393H37.7161V75.1595H37.5284V31.5393Z",
    fill: "#48009A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6531 31.5393H37.8408V75.1595H37.6531V31.5393Z",
    fill: "#49009A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7785 31.5393H37.9662V75.1595H37.7785V31.5393Z",
    fill: "#49009B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9032 31.5393H38.0909V75.1595H37.9032V31.5393Z",
    fill: "#4A009B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0287 31.5393H38.2155V75.1595H38.0287V31.5393Z",
    fill: "#4A009C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1534 31.5393H38.3411V75.1595H38.1534V31.5393Z",
    fill: "#4A009C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2788 31.5393H38.4656V75.1595H38.2788V31.5393Z",
    fill: "#4B009D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4028 31.5393H38.5905V75.1595H38.4028V31.5393Z",
    fill: "#4B009D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5282 31.5393H38.715V75.1595H38.5282V31.5393Z",
    fill: "#4C009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6529 31.5393H38.8406V75.1595H38.6529V31.5393Z",
    fill: "#4C009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7776 31.5393H38.9653V75.1595H38.7776V31.5393Z",
    fill: "#4C009F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9031 31.5393H39.0908V75.1595H38.9031V31.5393Z",
    fill: "#4D009F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0278 31.5393H39.2155V75.1595H39.0278V31.5393Z",
    fill: "#4D00A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1532 31.5393H39.3409V75.1595H39.1532V31.5393Z",
    fill: "#4D00A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2779 31.5393H39.4656V75.1595H39.2779V31.5393Z",
    fill: "#4E00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4034 31.5393H39.5902V75.1595H39.4034V31.5393Z",
    fill: "#4E00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5273 31.5393H39.715V75.1595H39.5273V31.5393Z",
    fill: "#4F00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6528 31.5393H39.8396V75.1595H39.6528V31.5393Z",
    fill: "#4F00A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7775 31.5393H39.9652V75.1595H39.7775V31.5393Z",
    fill: "#4F00A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9029 31.5393H40.0897V75.1595H39.9029V31.5393Z",
    fill: "#5000A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0276 31.5393H40.2153V75.1595H40.0276V31.5393Z",
    fill: "#5000A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1523 31.5393H40.34V75.1595H40.1523V31.5393Z",
    fill: "#5100A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2778 31.5393H40.4655V75.1595H40.2778V31.5393Z",
    fill: "#5100A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4017 31.5393H40.5895V75.1595H40.4017V31.5393Z",
    fill: "#5100A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5272 31.5393H40.714V75.1595H40.5272V31.5393Z",
    fill: "#5200A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6519 31.5393H40.8396V75.1595H40.6519V31.5393Z",
    fill: "#5200A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7773 31.5393H40.9641V75.1595H40.7773V31.5393Z",
    fill: "#5300A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.902 31.5393H41.0897V75.1595H40.902V31.5393Z",
    fill: "#5300A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0267 31.5393H41.2145V75.1595H41.0267V31.5393Z",
    fill: "#5300A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1522 31.5393H41.3399V75.1595H41.1522V31.5393Z",
    fill: "#5400A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2776 31.5393H41.4644V75.1595H41.2776V31.5393Z",
    fill: "#5400A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4016 31.5393H41.5884V75.1595H41.4016V31.5393Z",
    fill: "#5500A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5262 31.5393H41.714V75.1595H41.5262V31.5393Z",
    fill: "#5500A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6517 31.5393H41.8385V75.1595H41.6517V31.5393Z",
    fill: "#5500AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7764 31.5393H41.9641V75.1595H41.7764V31.5393Z",
    fill: "#5600AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9019 31.5393H42.0887V75.1595H41.9019V31.5393Z",
    fill: "#5600AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0266 31.5393H42.2143V75.1595H42.0266V31.5393Z",
    fill: "#5600AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1512 31.5393H42.339V75.1595H42.1512V31.5393Z",
    fill: "#5700AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2767 31.5393H42.4645V75.1595H42.2767V31.5393Z",
    fill: "#5700AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4006 31.5393H42.5884V75.1595H42.4006V31.5393Z",
    fill: "#5800AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5261 31.5393H42.7138V75.1595H42.5261V31.5393Z",
    fill: "#5800AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6508 31.5393H42.8385V75.1595H42.6508V31.5393Z",
    fill: "#5800AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7762 31.5393H42.963V75.1595H42.7762V31.5393Z",
    fill: "#5900AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9009 31.5393H43.0887V75.1595H42.9009V31.5393Z",
    fill: "#5900AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0264 31.5393H43.2132V75.1595H43.0264V31.5393Z",
    fill: "#5A00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1511 31.5393H43.3388V75.1595H43.1511V31.5393Z",
    fill: "#5A00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2766 31.5393H43.4634V75.1595H43.2766V31.5393Z",
    fill: "#5A00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4012 31.5393H43.589V75.1595H43.4012V31.5393Z",
    fill: "#5B00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5252 31.5393H43.7129V75.1595H43.5252V31.5393Z",
    fill: "#5B00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6514 31.5393H43.8391V75.1595H43.6514V31.5393Z",
    fill: "#5C00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7753 31.5393H43.9631V75.1595H43.7753V31.5393Z",
    fill: "#5C00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9008 31.5393H44.0885V75.1595H43.9008V31.5393Z",
    fill: "#5C00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0255 31.5393H44.2132V75.1595H44.0255V31.5393Z",
    fill: "#5D00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1509 31.5393H44.3377V75.1595H44.1509V31.5393Z",
    fill: "#5D00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2756 31.5393H44.4634V75.1595H44.2756V31.5393Z",
    fill: "#5E00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4011 31.5393H44.5879V75.1595H44.4011V31.5393Z",
    fill: "#5E00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5258 31.5393H44.7135V75.1595H44.5258V31.5393Z",
    fill: "#5E00B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6512 31.5393H44.838V75.1595H44.6512V31.5393Z",
    fill: "#5F00B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7752 31.5393H44.9629V75.1595H44.7752V31.5393Z",
    fill: "#5F00B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8999 31.5393H45.0876V75.1595H44.8999V31.5393Z",
    fill: "#6000B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0253 31.5393H45.2131V75.1595H45.0253V31.5393Z",
    fill: "#6000B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.15 31.5393H45.3377V75.1595H45.15V31.5393Z",
    fill: "#6000B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2755 31.5393H45.4632V75.1595H45.2755V31.5393Z",
    fill: "#6100B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4002 31.5393H45.5879V75.1595H45.4002V31.5393Z",
    fill: "#6100B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5256 31.5393H45.7124V75.1595H45.5256V31.5393Z",
    fill: "#6100B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6503 31.5393H45.8381V75.1595H45.6503V31.5393Z",
    fill: "#6200B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7743 31.5393H45.962V75.1595H45.7743V31.5393Z",
    fill: "#6200B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8998 31.5393H46.0875V75.1595H45.8998V31.5393Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0245 31.5393H46.2122V75.1595H46.0245V31.5393Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1499 31.5393H46.3367V75.1595H46.1499V31.5393Z",
    fill: "#6300BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2746 31.5393H46.4623V75.1595H46.2746V31.5393Z",
    fill: "#6400BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4 31.5393H46.5868V75.1595H46.4V31.5393Z",
    fill: "#6400BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5248 31.5393H46.7125V75.1595H46.5248V31.5393Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6502 31.5393H46.837V75.1595H46.6502V31.5393Z",
    fill: "#6500BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7742 31.5393H46.9619V75.1595H46.7742V31.5393Z",
    fill: "#6500BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8996 31.5393H47.0864V75.1595H46.8996V31.5393Z",
    fill: "#6600BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0243 31.5393H47.212V75.1595H47.0243V31.5393Z",
    fill: "#6600BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.149 31.5393H47.3367V75.1595H47.149V31.5393Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2745 31.5393H47.4622V75.1595H47.2745V31.5393Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3992 31.5393H47.5869V75.1595H47.3992V31.5393Z",
    fill: "#6700C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5246 31.5393H47.7114V75.1595H47.5246V31.5393Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6486 31.5393H47.8363V75.1595H47.6486V31.5393Z",
    fill: "#6800C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.774 31.5393H47.9608V75.1595H47.774V31.5393Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8987 31.5393H48.0864V75.1595H47.8987V31.5393Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0242 31.5393H48.211V75.1595H48.0242V31.5393Z",
    fill: "#6900C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1489 31.5393H48.3366V75.1595H48.1489V31.5393Z",
    fill: "#6A00C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2743 31.5393H48.4611V75.1595H48.2743V31.5393Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.399 31.5393H48.5867V75.1595H48.399V31.5393Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5237 31.5393H48.7114V75.1595H48.5237V31.5393Z",
    fill: "#6B00C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6492 31.5393H48.8369V75.1595H48.6492V31.5393Z",
    fill: "#6B00C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7739 31.5393H48.9616V75.1595H48.7739V31.5393Z",
    fill: "#6B00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8993 31.5393H49.0861V75.1595H48.8993V31.5393Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0233 31.5393H49.211V75.1595H49.0233V31.5393Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1487 31.5393H49.3355V75.1595H49.1487V31.5393Z",
    fill: "#6A00C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2734 31.5393H49.4611V75.1595H49.2734V31.5393Z",
    fill: "#6900C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3989 31.5393H49.5857V75.1595H49.3989V31.5393Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5236 31.5393H49.7113V75.1595H49.5236V31.5393Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6483 31.5393H49.836V75.1595H49.6483V31.5393Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7737 31.5393H49.9605V75.1595H49.7737V31.5393Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8984 31.5393H50.0861V75.1595H49.8984V31.5393Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0239 31.5393H50.2107V75.1595H50.0239V31.5393Z",
    fill: "#6800BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1478 31.5393H50.3355V75.1595H50.1478V31.5393Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2733 31.5393H50.4601V75.1595H50.2733V31.5393Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3979 31.5393H50.5857V75.1595H50.3979V31.5393Z",
    fill: "#6700BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5226 31.5393H50.7104V75.1595H50.5226V31.5393Z",
    fill: "#6700BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6481 31.5393H50.8358V75.1595H50.6481V31.5393Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7728 31.5393H50.9606V75.1595H50.7728V31.5393Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8983 31.5393H51.086V75.1595H50.8983V31.5393Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0222 31.5393H51.2099V75.1595H51.0222V31.5393Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1476 31.5393H51.3344V75.1595H51.1476V31.5393Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2723 31.5393H51.4601V75.1595H51.2723V31.5393Z",
    fill: "#6500BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3978 31.5393H51.5846V75.1595H51.3978V31.5393Z",
    fill: "#6500BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5225 31.5393H51.7102V75.1595H51.5225V31.5393Z",
    fill: "#6400BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6479 31.5393H51.8348V75.1595H51.6479V31.5393Z",
    fill: "#6400BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7726 31.5393H51.9604V75.1595H51.7726V31.5393Z",
    fill: "#6400BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8966 31.5393H52.0843V75.1595H51.8966V31.5393Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.022 31.5393H52.2098V75.1595H52.022V31.5393Z",
    fill: "#6300B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1467 31.5393H52.3344V75.1595H52.1467V31.5393Z",
    fill: "#6300B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2722 31.5393H52.459V75.1595H52.2722V31.5393Z",
    fill: "#6300B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3969 31.5393H52.5846V75.1595H52.3969V31.5393Z",
    fill: "#6200B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5223 31.5393H52.7091V75.1595H52.5223V31.5393Z",
    fill: "#6200B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.647 31.5393H52.8348V75.1595H52.647V31.5393Z",
    fill: "#6200B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7725 31.5393H52.9593V75.1595H52.7725V31.5393Z",
    fill: "#6100B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8972 31.5393H53.0849V75.1595H52.8972V31.5393Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0226 31.5393H53.2095V75.1595H53.0226V31.5393Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1466 31.5393H53.3343V75.1595H53.1466V31.5393Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2713 31.5393H53.459V75.1595H53.2713V31.5393Z",
    fill: "#6000B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3967 31.5393H53.5844V75.1595H53.3967V31.5393Z",
    fill: "#6000B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5214 31.5393H53.7091V75.1595H53.5214V31.5393Z",
    fill: "#6000B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6469 31.5393H53.8337V75.1595H53.6469V31.5393Z",
    fill: "#5F00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7716 31.5393H53.9593V75.1595H53.7716V31.5393Z",
    fill: "#5F00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.897 31.5393H54.0838V75.1595H53.897V31.5393Z",
    fill: "#5F00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0217 31.5393H54.2094V75.1595H54.0217V31.5393Z",
    fill: "#5F00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1472 31.5393H54.334V75.1595H54.1472V31.5393Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2719 31.5393H54.4596V75.1595H54.2719V31.5393Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3973 31.5393H54.5841V75.1595H54.3973V31.5393Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5213 31.5393H54.7081V75.1595H54.5213V31.5393Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.646 31.5393H54.8337V75.1595H54.646V31.5393Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7714 31.5393H54.9582V75.1595H54.7714V31.5393Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8961 31.5393H55.0838V75.1595H54.8961V31.5393Z",
    fill: "#5D00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0216 31.5393H55.2084V75.1595H55.0216V31.5393Z",
    fill: "#5C00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1463 31.5393H55.334V75.1595H55.1463V31.5393Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2703 31.5393H55.458V75.1595H55.2703V31.5393Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3957 31.5393H55.5834V75.1595H55.3957V31.5393Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5204 31.5393H55.7081V75.1595H55.5204V31.5393Z",
    fill: "#5B00AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6458 31.5393H55.8335V75.1595H55.6458V31.5393Z",
    fill: "#5B00AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7706 31.5393H55.9583V75.1595H55.7706V31.5393Z",
    fill: "#5B00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.896 31.5393H56.0828V75.1595H55.896V31.5393Z",
    fill: "#5A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0208 31.5393H56.2085V75.1595H56.0208V31.5393Z",
    fill: "#5A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1461 31.5393H56.3329V75.1595H56.1461V31.5393Z",
    fill: "#5A00AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2701 31.5393H56.4579V75.1595H56.2701V31.5393Z",
    fill: "#5A00AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3955 31.5393H56.5823V75.1595H56.3955V31.5393Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5203 31.5393H56.708V75.1595H56.5203V31.5393Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6449 31.5393H56.8326V75.1595H56.6449V31.5393Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7704 31.5393H56.9581V75.1595H56.7704V31.5393Z",
    fill: "#5800AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8951 31.5393H57.0829V75.1595H56.8951V31.5393Z",
    fill: "#5800AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0205 31.5393H57.2082V75.1595H57.0205V31.5393Z",
    fill: "#5800A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1453 31.5393H57.333V75.1595H57.1453V31.5393Z",
    fill: "#5800A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2708 31.5393H57.4576V75.1595H57.2708V31.5393Z",
    fill: "#5701A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3947 31.5393H57.5824V75.1595H57.3947V31.5393Z",
    fill: "#5701A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5201 31.5393H57.707V75.1595H57.5201V31.5393Z",
    fill: "#5701A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6448 31.5393H57.8325V75.1595H57.6448V31.5393Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7703 31.5393H57.9571V75.1595H57.7703V31.5393Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8949 31.5393H58.0826V75.1595H57.8949V31.5393Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0197 31.5393H58.2074V75.1595H58.0197V31.5393Z",
    fill: "#5601A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1451 31.5393H58.3329V75.1595H58.1451V31.5393Z",
    fill: "#5501A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.269 31.5393H58.4568V75.1595H58.269V31.5393Z",
    fill: "#5501A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3953 31.5393H58.5821V75.1595H58.3953V31.5393Z",
    fill: "#5501A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5192 31.5393H58.7069V75.1595H58.5192V31.5393Z",
    fill: "#5401A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6447 31.5393H58.8315V75.1595H58.6447V31.5393Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7693 31.5393H58.957V75.1595H58.7693V31.5393Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.894 31.5393H59.0818V75.1595H58.894V31.5393Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0195 31.5393H59.2073V75.1595H59.0195V31.5393Z",
    fill: "#5301A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1442 31.5393H59.3319V75.1595H59.1442V31.5393Z",
    fill: "#5301A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2697 31.5393H59.4565V75.1595H59.2697V31.5393Z",
    fill: "#5301A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3943 31.5393H59.582V75.1595H59.3943V31.5393Z",
    fill: "#5201A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5198 31.5393H59.7066V75.1595H59.5198V31.5393Z",
    fill: "#5201A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6438 31.5393H59.8315V75.1595H59.6438V31.5393Z",
    fill: "#5201A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7692 31.5393H59.956V75.1595H59.7692V31.5393Z",
    fill: "#5201A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8939 31.5393H60.0816V75.1595H59.8939V31.5393Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0193 31.5393H60.2061V75.1595H60.0193V31.5393Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.144 31.5393H60.3318V75.1595H60.144V31.5393Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2688 31.5393H60.4565V75.1595H60.2688V31.5393Z",
    fill: "#50019F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3942 31.5393H60.5819V75.1595H60.3942V31.5393Z",
    fill: "#50019F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5189 31.5393H60.7066V75.1595H60.5189V31.5393Z",
    fill: "#50019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6443 31.5393H60.8311V75.1595H60.6443V31.5393Z",
    fill: "#50019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7683 31.5393H60.956V75.1595H60.7683V31.5393Z",
    fill: "#4F019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8938 31.5393H61.0806V75.1595H60.8938V31.5393Z",
    fill: "#4F019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0184 31.5393H61.2062V75.1595H61.0184V31.5393Z",
    fill: "#4F019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1439 31.5393H61.3307V75.1595H61.1439V31.5393Z",
    fill: "#4E019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2686 31.5393H61.4563V75.1595H61.2686V31.5393Z",
    fill: "#4E019C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3933 31.5393H61.581V75.1595H61.3933V31.5393Z",
    fill: "#4E019C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5188 31.5393H61.7065V75.1595H61.5188V31.5393Z",
    fill: "#4E019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6427 31.5393H61.8304V75.1595H61.6427V31.5393Z",
    fill: "#4D019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7682 31.5393H61.9559V75.1595H61.7682V31.5393Z",
    fill: "#4D019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8928 31.5393H62.0805V75.1595H61.8928V31.5393Z",
    fill: "#4D019A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0183 31.5393H62.2051V75.1595H62.0183V31.5393Z",
    fill: "#4C019A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1429 31.5393H62.3307V75.1595H62.1429V31.5393Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2684 31.5393H62.4552V75.1595H62.2684V31.5393Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3932 31.5393H62.5809V75.1595H62.3932V31.5393Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5186 31.5393H62.7054V75.1595H62.5186V31.5393Z",
    fill: "#4B0198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6426 31.5393H62.8303V75.1595H62.6426V31.5393Z",
    fill: "#4B0198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7672 31.5393H62.9549V75.1595H62.7672V31.5393Z",
    fill: "#4B0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8927 31.5393H63.0804V75.1595H62.8927V31.5393Z",
    fill: "#4B0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0173 31.5393H63.2051V75.1595H63.0173V31.5393Z",
    fill: "#4A0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1428 31.5393H63.3305V75.1595H63.1428V31.5393Z",
    fill: "#4A0196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2676 31.5393H63.4553V75.1595H63.2676V31.5393Z",
    fill: "#4A0196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3929 31.5393H63.5798V75.1595H63.3929V31.5393Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5177 31.5393H63.7054V75.1595H63.5177V31.5393Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6416 31.5393H63.8293V75.1595H63.6416V31.5393Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7671 31.5393H63.9548V75.1595H63.7671V31.5393Z",
    fill: "#490194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8918 31.5393H64.0796V75.1595H63.8918V31.5393Z",
    fill: "#480194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0172 31.5393H64.204V75.1595H64.0172V31.5393Z",
    fill: "#480193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.142 31.5393H64.3297V75.1595H64.142V31.5393Z",
    fill: "#480193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2673 31.5393H64.4541V75.1595H64.2673V31.5393Z",
    fill: "#470193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3921 31.5393H64.5798V75.1595H64.3921V31.5393Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5176 31.5393H64.7044V75.1595H64.5176V31.5393Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6422 31.5393H64.8299V75.1595H64.6422V31.5393Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7677 31.5393H64.9545V75.1595H64.7677V31.5393Z",
    fill: "#460191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8923 31.5393H65.0801V75.1595H64.8923V31.5393Z",
    fill: "#460191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0164 31.5393H65.2041V75.1595H65.0164V31.5393Z",
    fill: "#460190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1418 31.5393H65.3296V75.1595H65.1418V31.5393Z",
    fill: "#450190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2665 31.5393H65.4542V75.1595H65.2665V31.5393Z",
    fill: "#450190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.392 31.5393H65.5788V75.1595H65.392V31.5393Z",
    fill: "#45018F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5166 31.5393H65.7043V75.1595H65.5166V31.5393Z",
    fill: "#45018F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6421 31.5393H65.8289V75.1595H65.6421V31.5393Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7668 31.5393H65.9546V75.1595H65.7668V31.5393Z",
    fill: "#44018E"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.112 0.000150707C173.721 0.0129708 175.834 2.12553 175.847 4.73533C175.847 9.51629 167.143 14.2515 167.143 14.2515C167.143 14.2515 158.439 9.4467 158.439 4.73533C158.439 2.12004 160.559 0.000150707 163.174 0.000150707C164.775 -0.0126693 166.272 0.793162 167.143 2.1356C168.02 0.799572 169.514 -0.00351216 171.112 0.000150707Z",
    fill: "#4F46E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3554 73.8679V63.0511H88.6441V64.9367H83.6424V67.5141H88.2691V69.3997H83.6424V71.9824H88.6652V73.8679H81.3554ZM93.4094 74C92.7932 74 92.2351 73.8415 91.7351 73.5246C91.2387 73.2042 90.8443 72.7341 90.5521 72.1144C90.2633 71.4912 90.119 70.7271 90.119 69.8222C90.119 68.8926 90.2686 68.1197 90.5679 67.5035C90.8672 66.8838 91.2651 66.4208 91.7616 66.1145C92.2616 65.8046 92.8091 65.6497 93.4041 65.6497C93.8584 65.6497 94.2369 65.7272 94.5397 65.8821C94.846 66.0335 95.0925 66.2236 95.2791 66.4525C95.4693 66.6779 95.6136 66.8997 95.7122 67.118H95.7809V63.0511H98.0256V73.8679H95.8073V72.5686H95.7122C95.6066 72.794 95.4569 73.0176 95.2633 73.2394C95.0731 73.4577 94.8249 73.639 94.5186 73.7834C94.2158 73.9278 93.846 74 93.4094 74ZM94.1224 72.2095C94.4851 72.2095 94.7915 72.1109 95.0415 71.9137C95.295 71.713 95.4886 71.4331 95.6224 71.0739C95.7598 70.7148 95.8284 70.294 95.8284 69.8116C95.8284 69.3292 95.7615 68.9102 95.6277 68.5546C95.4939 68.199 95.3003 67.9243 95.0467 67.7307C94.7932 67.537 94.4851 67.4402 94.1224 67.4402C93.7527 67.4402 93.4411 67.5405 93.1876 67.7412C92.9341 67.9419 92.7422 68.2201 92.6119 68.5757C92.4816 68.9314 92.4165 69.3433 92.4165 69.8116C92.4165 70.2834 92.4816 70.7007 92.6119 71.0634C92.7457 71.4225 92.9376 71.7042 93.1876 71.9084C93.4411 72.1091 93.7527 72.2095 94.1224 72.2095ZM105.078 70.4137V65.7553H107.328V73.8679H105.168V72.3943H105.083C104.9 72.8697 104.595 73.2517 104.169 73.5405C103.747 73.8292 103.231 73.9736 102.622 73.9736C102.08 73.9736 101.603 73.8503 101.191 73.6038C100.779 73.3574 100.456 73.007 100.224 72.5528C99.9952 72.0986 99.879 71.5546 99.8755 70.9208V65.7553H102.125V70.5194C102.129 70.9982 102.257 71.3767 102.511 71.6549C102.765 71.9331 103.104 72.0722 103.53 72.0722C103.801 72.0722 104.055 72.0105 104.291 71.8873C104.527 71.7605 104.717 71.5739 104.861 71.3275C105.009 71.081 105.081 70.7764 105.078 70.4137ZM112.793 74.0264C111.962 74.0264 111.247 73.8503 110.649 73.4982C110.054 73.1426 109.596 72.6496 109.275 72.0193C108.959 71.3891 108.8 70.6637 108.8 69.8433C108.8 69.0123 108.96 68.2835 109.281 67.6567C109.605 67.0264 110.064 66.5352 110.659 66.1831C111.254 65.8275 111.962 65.6497 112.782 65.6497C113.49 65.6497 114.11 65.7782 114.642 66.0353C115.173 66.2923 115.594 66.6532 115.904 67.118C116.214 67.5828 116.385 68.1285 116.416 68.7553H114.293C114.233 68.3504 114.075 68.0247 113.818 67.7782C113.564 67.5282 113.231 67.4032 112.819 67.4032C112.471 67.4032 112.166 67.4983 111.906 67.6884C111.649 67.875 111.448 68.1479 111.304 68.5071C111.159 68.8662 111.087 69.3011 111.087 69.8116C111.087 70.3292 111.157 70.7694 111.298 71.132C111.443 71.4947 111.645 71.7711 111.906 71.9612C112.166 72.1514 112.471 72.2465 112.819 72.2465C113.076 72.2465 113.307 72.1936 113.511 72.088C113.719 71.9824 113.89 71.8292 114.024 71.6285C114.161 71.4243 114.251 71.1796 114.293 70.8944H116.416C116.381 71.5141 116.212 72.0598 115.909 72.5317C115.61 73 115.196 73.3662 114.668 73.6302C114.14 73.8943 113.515 74.0264 112.793 74.0264ZM120.17 74.0211C119.653 74.0211 119.191 73.9313 118.786 73.7517C118.381 73.5686 118.061 73.2993 117.825 72.9436C117.593 72.5845 117.477 72.1373 117.477 71.6021C117.477 71.1514 117.559 70.7729 117.725 70.4665C117.89 70.1602 118.116 69.9137 118.401 69.7271C118.686 69.5405 119.01 69.3997 119.373 69.3046C119.739 69.2095 120.123 69.1426 120.524 69.1039C120.996 69.0546 121.376 69.0088 121.665 68.9666C121.954 68.9208 122.163 68.8539 122.293 68.7659C122.424 68.6778 122.489 68.5476 122.489 68.375V68.3433C122.489 68.0088 122.383 67.75 122.172 67.5669C121.964 67.3838 121.668 67.2923 121.285 67.2923C120.88 67.2923 120.557 67.3821 120.318 67.5616C120.079 67.7377 119.92 67.9595 119.843 68.2271L117.762 68.0581C117.867 67.5652 118.075 67.1391 118.385 66.78C118.695 66.4173 119.094 66.1391 119.584 65.9455C120.077 65.7483 120.647 65.6497 121.295 65.6497C121.746 65.6497 122.177 65.7025 122.589 65.8081C123.005 65.9138 123.373 66.0775 123.693 66.2993C124.017 66.5212 124.272 66.8064 124.459 67.155C124.645 67.5 124.739 67.9138 124.739 68.3961V73.8679H122.605V72.7429H122.542C122.411 72.9964 122.237 73.22 122.019 73.4137C121.8 73.6038 121.538 73.7535 121.232 73.8626C120.925 73.9683 120.572 74.0211 120.17 74.0211ZM120.815 72.4683C121.146 72.4683 121.438 72.4031 121.691 72.2729C121.945 72.1391 122.144 71.9595 122.288 71.7341C122.432 71.5088 122.505 71.2535 122.505 70.9683V70.1074C122.434 70.1532 122.337 70.1954 122.214 70.2342C122.094 70.2694 121.959 70.3028 121.807 70.3345C121.656 70.3627 121.505 70.3891 121.353 70.4137C121.202 70.4349 121.065 70.4542 120.941 70.4718C120.677 70.5106 120.447 70.5722 120.249 70.6567C120.052 70.7412 119.899 70.8556 119.79 71C119.681 71.1408 119.626 71.3169 119.626 71.5282C119.626 71.8345 119.737 72.0686 119.959 72.2306C120.184 72.3891 120.469 72.4683 120.815 72.4683ZM130.799 65.7553V67.4455H125.914V65.7553H130.799ZM127.023 63.8117H129.273V71.375C129.273 71.5827 129.305 71.7447 129.368 71.8609C129.432 71.9736 129.52 72.0528 129.632 72.0986C129.748 72.1443 129.882 72.1672 130.034 72.1672C130.139 72.1672 130.245 72.1584 130.351 72.1408C130.456 72.1197 130.537 72.1039 130.593 72.0933L130.947 73.7676C130.835 73.8028 130.676 73.8433 130.472 73.889C130.268 73.9383 130.02 73.9683 129.727 73.9788C129.185 74 128.71 73.9278 128.301 73.7623C127.896 73.5968 127.581 73.3398 127.356 72.9912C127.13 72.6426 127.02 72.2024 127.023 71.6708V63.8117ZM132.265 73.8679V65.7553H134.515V73.8679H132.265ZM133.395 64.7096C133.061 64.7096 132.774 64.5986 132.534 64.3768C132.299 64.1515 132.181 63.8821 132.181 63.5687C132.181 63.2589 132.299 62.993 132.534 62.7712C132.774 62.5459 133.061 62.4332 133.395 62.4332C133.73 62.4332 134.015 62.5459 134.251 62.7712C134.49 62.993 134.61 63.2589 134.61 63.5687C134.61 63.8821 134.49 64.1515 134.251 64.3768C134.015 64.5986 133.73 64.7096 133.395 64.7096ZM139.983 74.0264C139.162 74.0264 138.453 73.8521 137.854 73.5035C137.259 73.1514 136.8 72.6619 136.476 72.0352C136.152 71.4049 135.99 70.6743 135.99 69.8433C135.99 69.0053 136.152 68.2729 136.476 67.6462C136.8 67.0159 137.259 66.5264 137.854 66.1779C138.453 65.8257 139.162 65.6497 139.983 65.6497C140.803 65.6497 141.511 65.8257 142.106 66.1779C142.705 66.5264 143.166 67.0159 143.49 67.6462C143.814 68.2729 143.976 69.0053 143.976 69.8433C143.976 70.6743 143.814 71.4049 143.49 72.0352C143.166 72.6619 142.705 73.1514 142.106 73.5035C141.511 73.8521 140.803 74.0264 139.983 74.0264ZM139.993 72.2834C140.367 72.2834 140.678 72.1778 140.928 71.9665C141.178 71.7517 141.367 71.4595 141.493 71.0898C141.624 70.7201 141.689 70.2993 141.689 69.8275C141.689 69.3556 141.624 68.9349 141.493 68.5652C141.367 68.1954 141.178 67.9032 140.928 67.6884C140.678 67.4736 140.367 67.3662 139.993 67.3662C139.617 67.3662 139.3 67.4736 139.043 67.6884C138.789 67.9032 138.597 68.1954 138.467 68.5652C138.34 68.9349 138.277 69.3556 138.277 69.8275C138.277 70.2993 138.34 70.7201 138.467 71.0898C138.597 71.4595 138.789 71.7517 139.043 71.9665C139.3 72.1778 139.617 72.2834 139.993 72.2834ZM147.689 69.1778V73.8679H145.439V65.7553H147.583V67.1867H147.678C147.858 66.7148 148.159 66.3416 148.581 66.0669C149.004 65.7888 149.516 65.6497 150.118 65.6497C150.682 65.6497 151.173 65.7729 151.592 66.0194C152.011 66.2659 152.337 66.618 152.569 67.0757C152.801 67.53 152.918 68.0722 152.918 68.7025V73.8679H150.668V69.1039C150.671 68.6074 150.544 68.2201 150.287 67.9419C150.03 67.6602 149.676 67.5194 149.226 67.5194C148.923 67.5194 148.655 67.5845 148.423 67.7148C148.194 67.8451 148.015 68.0352 147.884 68.2852C147.757 68.5317 147.692 68.8292 147.689 69.1778ZM157.004 74.0211C156.487 74.0211 156.025 73.9313 155.62 73.7517C155.216 73.5686 154.895 73.2993 154.659 72.9436C154.427 72.5845 154.311 72.1373 154.311 71.6021C154.311 71.1514 154.393 70.7729 154.559 70.4665C154.724 70.1602 154.95 69.9137 155.235 69.7271C155.52 69.5405 155.844 69.3997 156.207 69.3046C156.573 69.2095 156.957 69.1426 157.358 69.1039C157.83 69.0546 158.21 69.0088 158.499 68.9666C158.788 68.9208 158.997 68.8539 159.128 68.7659C159.258 68.6778 159.323 68.5476 159.323 68.375V68.3433C159.323 68.0088 159.217 67.75 159.006 67.5669C158.798 67.3838 158.503 67.2923 158.119 67.2923C157.714 67.2923 157.392 67.3821 157.152 67.5616C156.913 67.7377 156.754 67.9595 156.677 68.2271L154.596 68.0581C154.701 67.5652 154.909 67.1391 155.219 66.78C155.529 66.4173 155.929 66.1391 156.418 65.9455C156.911 65.7483 157.481 65.6497 158.129 65.6497C158.58 65.6497 159.011 65.7025 159.423 65.8081C159.839 65.9138 160.207 66.0775 160.527 66.2993C160.851 66.5212 161.106 66.8064 161.293 67.155C161.48 67.5 161.573 67.9138 161.573 68.3961V73.8679H159.439V72.7429H159.376C159.245 72.9964 159.071 73.22 158.853 73.4137C158.635 73.6038 158.372 73.7535 158.066 73.8626C157.76 73.9683 157.406 74.0211 157.004 74.0211ZM157.649 72.4683C157.98 72.4683 158.272 72.4031 158.525 72.2729C158.779 72.1391 158.978 71.9595 159.122 71.7341C159.267 71.5088 159.339 71.2535 159.339 70.9683V70.1074C159.268 70.1532 159.172 70.1954 159.048 70.2342C158.929 70.2694 158.793 70.3028 158.642 70.3345C158.49 70.3627 158.339 70.3891 158.187 70.4137C158.036 70.4349 157.899 70.4542 157.775 70.4718C157.511 70.5106 157.281 70.5722 157.084 70.6567C156.886 70.7412 156.733 70.8556 156.624 71C156.515 71.1408 156.46 71.3169 156.46 71.5282C156.46 71.8345 156.571 72.0686 156.793 72.2306C157.018 72.3891 157.304 72.4683 157.649 72.4683ZM165.568 63.0511V73.8679H163.318V63.0511H165.568ZM170.855 63.0511H173.676L176.655 70.3187H176.781L179.76 63.0511H182.581V73.8679H180.362V66.8275H180.273L177.473 73.8151H175.963L173.163 66.8011H173.074V73.8679H170.855V63.0511ZM188.12 74.0264C187.285 74.0264 186.567 73.8574 185.965 73.5193C185.366 73.1778 184.905 72.6954 184.581 72.0722C184.257 71.4454 184.095 70.7042 184.095 69.8486C184.095 69.0141 184.257 68.2817 184.581 67.6514C184.905 67.0212 185.361 66.53 185.949 66.1779C186.541 65.8257 187.234 65.6497 188.03 65.6497C188.565 65.6497 189.063 65.736 189.525 65.9085C189.989 66.0775 190.394 66.3328 190.739 66.6743C191.088 67.0159 191.359 67.4455 191.553 67.9631C191.746 68.4771 191.843 69.0792 191.843 69.7694V70.3873H184.993V68.993H189.725C189.725 68.669 189.655 68.3821 189.514 68.1321C189.373 67.8821 189.178 67.6866 188.928 67.5458C188.681 67.4014 188.394 67.3293 188.067 67.3293C187.725 67.3293 187.423 67.4085 187.158 67.5669C186.898 67.7219 186.694 67.9314 186.546 68.1954C186.398 68.456 186.322 68.7465 186.319 69.0669V70.3926C186.319 70.794 186.393 71.1408 186.541 71.4331C186.692 71.7253 186.905 71.9507 187.18 72.1091C187.454 72.2676 187.78 72.3468 188.157 72.3468C188.407 72.3468 188.636 72.3116 188.843 72.2412C189.051 72.1708 189.229 72.0651 189.377 71.9243C189.525 71.7834 189.637 71.6109 189.715 71.4067L191.796 71.544C191.69 72.044 191.474 72.4806 191.146 72.8538C190.822 73.2236 190.403 73.5123 189.889 73.72C189.379 73.9243 188.789 74.0264 188.12 74.0264ZM195.562 69.1778V73.8679H193.312V65.7553H195.456V67.1867H195.551C195.731 66.7148 196.032 66.3416 196.454 66.0669C196.877 65.7888 197.389 65.6497 197.991 65.6497C198.554 65.6497 199.046 65.7729 199.465 66.0194C199.884 66.2659 200.209 66.618 200.442 67.0757C200.674 67.53 200.79 68.0722 200.79 68.7025V73.8679H198.54V69.1039C198.544 68.6074 198.417 68.2201 198.16 67.9419C197.903 67.6602 197.549 67.5194 197.099 67.5194C196.796 67.5194 196.528 67.5845 196.296 67.7148C196.067 67.8451 195.887 68.0352 195.757 68.2852C195.63 68.5317 195.565 68.8292 195.562 69.1778ZM206.879 65.7553V67.4455H201.993V65.7553H206.879ZM203.102 63.8117H205.352V71.375C205.352 71.5827 205.384 71.7447 205.447 71.8609C205.511 71.9736 205.599 72.0528 205.712 72.0986C205.828 72.1443 205.962 72.1672 206.113 72.1672C206.219 72.1672 206.324 72.1584 206.43 72.1408C206.535 72.1197 206.616 72.1039 206.673 72.0933L207.027 73.7676C206.914 73.8028 206.756 73.8433 206.551 73.889C206.347 73.9383 206.099 73.9683 205.807 73.9788C205.264 74 204.789 73.9278 204.381 73.7623C203.976 73.5968 203.66 73.3398 203.435 72.9912C203.21 72.6426 203.099 72.2024 203.102 71.6708V63.8117ZM211.923 74.0264C211.102 74.0264 210.393 73.8521 209.794 73.5035C209.199 73.1514 208.74 72.6619 208.416 72.0352C208.092 71.4049 207.93 70.6743 207.93 69.8433C207.93 69.0053 208.092 68.2729 208.416 67.6462C208.74 67.0159 209.199 66.5264 209.794 66.1779C210.393 65.8257 211.102 65.6497 211.923 65.6497C212.743 65.6497 213.451 65.8257 214.046 66.1779C214.645 66.5264 215.106 67.0159 215.43 67.6462C215.754 68.2729 215.916 69.0053 215.916 69.8433C215.916 70.6743 215.754 71.4049 215.43 72.0352C215.106 72.6619 214.645 73.1514 214.046 73.5035C213.451 73.8521 212.743 74.0264 211.923 74.0264ZM211.933 72.2834C212.307 72.2834 212.618 72.1778 212.868 71.9665C213.118 71.7517 213.307 71.4595 213.433 71.0898C213.564 70.7201 213.629 70.2993 213.629 69.8275C213.629 69.3556 213.564 68.9349 213.433 68.5652C213.307 68.1954 213.118 67.9032 212.868 67.6884C212.618 67.4736 212.307 67.3662 211.933 67.3662C211.557 67.3662 211.24 67.4736 210.983 67.6884C210.729 67.9032 210.537 68.1954 210.407 68.5652C210.28 68.9349 210.217 69.3556 210.217 69.8275C210.217 70.2993 210.28 70.7201 210.407 71.0898C210.537 71.4595 210.729 71.7517 210.983 71.9665C211.24 72.1778 211.557 72.2834 211.933 72.2834ZM217.379 73.8679V65.7553H219.56V67.1708H219.644C219.792 66.6673 220.041 66.287 220.389 66.03C220.738 65.7694 221.139 65.6391 221.593 65.6391C221.706 65.6391 221.828 65.6462 221.958 65.6603C222.088 65.6743 222.203 65.6937 222.301 65.7184V67.7148C222.196 67.6831 222.049 67.655 221.863 67.6303C221.676 67.6057 221.505 67.5933 221.35 67.5933C221.019 67.5933 220.724 67.6655 220.463 67.8099C220.206 67.9507 220.002 68.1479 219.85 68.4014C219.703 68.6549 219.629 68.9472 219.629 69.2782V73.8679H217.379Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c626b87e3f5394c158bee0649935e867.svg";
export { ForwardRef as ReactComponent };